// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file yatayat/demo/v1/demo.proto (package yatayat.demo.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_yatayat_auth_v1_access } from "../../auth/v1/access_pb";
import type { StaffRole } from "../../auth/v1/auth_pb";
import { file_yatayat_auth_v1_auth } from "../../auth/v1/auth_pb";
import type { LocalizedName } from "../../types/v1/types_pb";
import { file_yatayat_types_v1_types } from "../../types/v1/types_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file yatayat/demo/v1/demo.proto.
 */
export const file_yatayat_demo_v1_demo: GenFile = /*@__PURE__*/
  fileDesc("Chp5YXRheWF0L2RlbW8vdjEvZGVtby5wcm90bxIPeWF0YXlhdC5kZW1vLnYxIkEKClNtc01lc3NhZ2USEQoJdG9fbWFza2VkGAEgASgJEgwKBGJvZHkYAiABKAkSEgoKc2VudF9hdF9tcxgDIAEoAyIlChRMaXN0U21zT3V0Ym94UmVxdWVzdBINCgVsaW1pdBgBIAEoBSJGChVMaXN0U21zT3V0Ym94UmVzcG9uc2USLQoIbWVzc2FnZXMYASADKAsyGy55YXRheWF0LmRlbW8udjEuU21zTWVzc2FnZSKJAQoJRGVtb1N0YWZmEgwKBG5hbWUYASABKAkSKAoEcm9sZRgCIAEoDjIaLnlhdGF5YXQuYXV0aC52MS5TdGFmZlJvbGUSNQoMb3JnYW5pc2F0aW9uGAMgASgLMh8ueWF0YXlhdC50eXBlcy52MS5Mb2NhbGl6ZWROYW1lEg0KBXBob25lGAQgASgJIhYKFExpc3REZW1vU3RhZmZSZXF1ZXN0IkIKFUxpc3REZW1vU3RhZmZSZXNwb25zZRIpCgVzdGFmZhgBIAMoCzIaLnlhdGF5YXQuZGVtby52MS5EZW1vU3RhZmYy3wEKC0RlbW9TZXJ2aWNlEmcKDUxpc3RTbXNPdXRib3gSJS55YXRheWF0LmRlbW8udjEuTGlzdFNtc091dGJveFJlcXVlc3QaJi55YXRheWF0LmRlbW8udjEuTGlzdFNtc091dGJveFJlc3BvbnNlIgeQAgHI8xgBEmcKDUxpc3REZW1vU3RhZmYSJS55YXRheWF0LmRlbW8udjEuTGlzdERlbW9TdGFmZlJlcXVlc3QaJi55YXRheWF0LmRlbW8udjEuTGlzdERlbW9TdGFmZlJlc3BvbnNlIgeQAgHI8xgBQsIBChNjb20ueWF0YXlhdC5kZW1vLnYxQglEZW1vUHJvdG9QAVpCZ2l0aHViLmNvbS9hYmRoZXNobmF5YWsveWF0YXlhdC9iYWNrZW5kL2dlbi95YXRheWF0L2RlbW8vdjE7ZGVtb3YxogIDWURYqgIPWWF0YXlhdC5EZW1vLlYxygIPWWF0YXlhdFxEZW1vXFYx4gIbWWF0YXlhdFxEZW1vXFYxXEdQQk1ldGFkYXRh6gIRWWF0YXlhdDo6RGVtbzo6VjFiBnByb3RvMw", [file_yatayat_auth_v1_access, file_yatayat_auth_v1_auth, file_yatayat_types_v1_types]);

/**
 * @generated from message yatayat.demo.v1.SmsMessage
 */
export type SmsMessage = Message<"yatayat.demo.v1.SmsMessage"> & {
  /**
   * @generated from field: string to_masked = 1;
   */
  toMasked: string;

  /**
   * @generated from field: string body = 2;
   */
  body: string;

  /**
   * @generated from field: int64 sent_at_ms = 3;
   */
  sentAtMs: bigint;
};

/**
 * Describes the message yatayat.demo.v1.SmsMessage.
 * Use `create(SmsMessageSchema)` to create a new message.
 */
export const SmsMessageSchema: GenMessage<SmsMessage> = /*@__PURE__*/
  messageDesc(file_yatayat_demo_v1_demo, 0);

/**
 * @generated from message yatayat.demo.v1.ListSmsOutboxRequest
 */
export type ListSmsOutboxRequest = Message<"yatayat.demo.v1.ListSmsOutboxRequest"> & {
  /**
   * @generated from field: int32 limit = 1;
   */
  limit: number;
};

/**
 * Describes the message yatayat.demo.v1.ListSmsOutboxRequest.
 * Use `create(ListSmsOutboxRequestSchema)` to create a new message.
 */
export const ListSmsOutboxRequestSchema: GenMessage<ListSmsOutboxRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_demo_v1_demo, 1);

/**
 * @generated from message yatayat.demo.v1.ListSmsOutboxResponse
 */
export type ListSmsOutboxResponse = Message<"yatayat.demo.v1.ListSmsOutboxResponse"> & {
  /**
   * @generated from field: repeated yatayat.demo.v1.SmsMessage messages = 1;
   */
  messages: SmsMessage[];
};

/**
 * Describes the message yatayat.demo.v1.ListSmsOutboxResponse.
 * Use `create(ListSmsOutboxResponseSchema)` to create a new message.
 */
export const ListSmsOutboxResponseSchema: GenMessage<ListSmsOutboxResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_demo_v1_demo, 2);

/**
 * @generated from message yatayat.demo.v1.DemoStaff
 */
export type DemoStaff = Message<"yatayat.demo.v1.DemoStaff"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: yatayat.auth.v1.StaffRole role = 2;
   */
  role: StaffRole;

  /**
   * The operator or authority the account acts for.
   *
   * @generated from field: yatayat.types.v1.LocalizedName organisation = 3;
   */
  organisation?: LocalizedName | undefined;

  /**
   * Unmasked: demo accounts only, and the outbox already shows their codes.
   *
   * @generated from field: string phone = 4;
   */
  phone: string;
};

/**
 * Describes the message yatayat.demo.v1.DemoStaff.
 * Use `create(DemoStaffSchema)` to create a new message.
 */
export const DemoStaffSchema: GenMessage<DemoStaff> = /*@__PURE__*/
  messageDesc(file_yatayat_demo_v1_demo, 3);

/**
 * @generated from message yatayat.demo.v1.ListDemoStaffRequest
 */
export type ListDemoStaffRequest = Message<"yatayat.demo.v1.ListDemoStaffRequest"> & {
};

/**
 * Describes the message yatayat.demo.v1.ListDemoStaffRequest.
 * Use `create(ListDemoStaffRequestSchema)` to create a new message.
 */
export const ListDemoStaffRequestSchema: GenMessage<ListDemoStaffRequest> = /*@__PURE__*/
  messageDesc(file_yatayat_demo_v1_demo, 4);

/**
 * @generated from message yatayat.demo.v1.ListDemoStaffResponse
 */
export type ListDemoStaffResponse = Message<"yatayat.demo.v1.ListDemoStaffResponse"> & {
  /**
   * @generated from field: repeated yatayat.demo.v1.DemoStaff staff = 1;
   */
  staff: DemoStaff[];
};

/**
 * Describes the message yatayat.demo.v1.ListDemoStaffResponse.
 * Use `create(ListDemoStaffResponseSchema)` to create a new message.
 */
export const ListDemoStaffResponseSchema: GenMessage<ListDemoStaffResponse> = /*@__PURE__*/
  messageDesc(file_yatayat_demo_v1_demo, 5);

/**
 * DemoService shows what mock adapters did and which demo accounts exist, so a demo
 * can run without real SMS. It answers only while the outbox SMS adapter is configured.
 *
 * @generated from service yatayat.demo.v1.DemoService
 */
export const DemoService: GenService<{
  /**
   * ListSmsOutbox returns the latest messages the mock SMS adapter "sent".
   *
   * @generated from rpc yatayat.demo.v1.DemoService.ListSmsOutbox
   */
  listSmsOutbox: {
    methodKind: "unary";
    input: typeof ListSmsOutboxRequestSchema;
    output: typeof ListSmsOutboxResponseSchema;
  },
  /**
   * ListDemoStaff lists the staff accounts a presenter can sign in as.
   *
   * @generated from rpc yatayat.demo.v1.DemoService.ListDemoStaff
   */
  listDemoStaff: {
    methodKind: "unary";
    input: typeof ListDemoStaffRequestSchema;
    output: typeof ListDemoStaffResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_yatayat_demo_v1_demo, 0);

